import { useState } from 'react';
import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import CancelServiceContract from './Modals/CancelServiceContract';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';
import { useDispatch } from 'react-redux';

function List() {
    const dispatch = useDispatch();

    const profileFilter = chooseProfileFilter();

    dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });

    const [showCancelModal, setShowCancelModal] = useState(false);
    const [selectedServiceContract, setSelectedServiceContract] = useState(null);

    const openCancelModal = (serviceContract) => {
        setSelectedServiceContract(serviceContract);
        setShowCancelModal(true);
    };

    const closeCancelModal = () => {
        setSelectedServiceContract(null);
        setShowCancelModal(false);
    };

    const pathFrontEnd = '/gci/service-contracts/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/service-contracts/delete`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        endpoint: `${endpointBackend}gci/service-contracts/getall`
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.gci_company_id ? {
                name: 'gci_company_id',
                type: 'select',
                label: 'Empresa',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllCompanies,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 4
            } : {},
            {
                name: 'status',
                type: 'select',
                label: 'Status',
                options: [
                    { label: 'Ativo', value: 'active' },
                    { label: 'Inativo', value: 'inactive' },
                    { label: 'Projeção', value: 'projection' }
                ],
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Contratos de Prestação de Serviços',
        labelTitleButtonAdd: 'Incluir novo contrato',
        fieldsShowOnDelete: ['identification'],
        formFilters: filters,
        filter: {
            ...profileFilter
        },
        canDelete: false,
        columns: [
            {
                name: 'identification',
                label: 'Identificação'
            },
            {
                name: 'company',
                label: 'Empresa'
            },
            {
                name: 'formattedStatus',
                label: 'Status'
            },
            {
                name: 'value',
                label: 'Valor'
            }
        ],
        columnsButtons: [
            {
                buttons: [
                    {
                        label: 'Cancelar',
                        icon: 'fas fa-cancel',
                        onClick: async item => {
                            openCancelModal(item);
                        },
                        width: '10%'
                    }
                ]
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />

            {/* --------------------------
                MODAL DE CANCELAMENTO
            --------------------------- */}
            {showCancelModal && (
                <CancelServiceContract
                    show={showCancelModal}
                    onClose={closeCancelModal}
                    serviceContractId={selectedServiceContract?.id}
                />
            )}
        </div>
    );
}

export default List;
